/**
 * Who counts as a counter.
 *
 * A counter sign-in sits at one party and works its own stock: a mitr, an
 * outlet, a retail dealer, or the distributor's own store. It gets the counter
 * portal — stock, Sell, its papers — rather than the office rails.
 *
 * The store desk is a counter too (15 Sep 2026: "add dispatch desk and rights
 * to vivek as well"). It sells from the store like any of them; what it has in
 * addition is the order desk and the dispatch form, which is a matter of extra
 * rights on top, not a different kind of screen.
 */
import { placesOrders, placesOutletOrdersOnly as outletOrdersOnly, type RoleKey } from '@bright/shared';

export const COUNTER_ROLES: RoleKey[] = ['BUYER', 'STORE_DESK'];

export function isCounterRole(key: string | null | undefined): boolean {
  return !!key && (COUNTER_ROLES as string[]).includes(key);
}

/** A counter that also sends stock on to the book's own counters. */
export function isStoreDesk(key: string | null | undefined): boolean {
  return key === 'STORE_DESK';
}

type OrderingUser = { role?: { key: string }; ordersForOutlets?: boolean; ordersForAll?: boolean } | null | undefined;

/**
 * Whether this sign-in may place a stock order: an ASM of either rank, the
 * store desk or an administrator (1 Oct 2026) by role; one person who places orders for any counter (owner,
 * 1 Oct 2026: "jitendra should also be able place order as well for bright on
 * wheels"); or one who places them for the company outlets (owner, 30 Sep
 * 2026: "give surbhi rights back to place orders she will place the orders for
 * outlets").
 */
export function mayPlaceOrders(user: OrderingUser): boolean {
  return placesOrders(user?.role?.key) || Boolean(user?.ordersForAll) || Boolean(user?.ordersForOutlets);
}

/** Places orders only for the company outlets: the form offers outlets and nothing else. */
export function placesOutletOrdersOnly(user: OrderingUser): boolean {
  return outletOrdersOnly(user?.role?.key, user ?? {});
}
